import { Badge } from 'reactstrap';
import alertsService from '@services/alerts';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
export const alertsTableConfig = () => {
  return [
    {
      title: 'Employee',
      dataIndex: 'employeeName',
      key: 'id',
      render: (text, record) => {
        if (record.children) {
          return (
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
            >
              {record.employeeName} ({record.children?.length ?? ''})
            </Text>
          );
        }
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {record.employeeName}
          </Text>
        );
      },
    },
    {
      title: 'Team',
      dataIndex: 'teamName',
      key: 'id',
      render: (text, record) => {
        if (record.children) {
          return (
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
            >
              {record.teamName}
            </Text>
          );
        }
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {record.teamName}
          </Text>
        );
      },
    },
    {
      title: 'Current Productivity',
      dataIndex: 'currentProductivity',
      key: 'id',
      render: (text, record, index) => {
        if (record.children) {
          return (
            <div>
              {
                <Badge
                  color={
                    record.currentProductivity < record.expectedProductivity
                      ? 'danger'
                      : 'success'
                  }
                  pill
                >
                  <Text
                    variant={textVariantsEnum.Text_xs}
                    fontWeight={fontWeightEnum.Medium}
                  >
                    {record.currentProductivity?.toFixed(2)}%
                  </Text>
                </Badge>
              }
            </div>
          );
        }
        return (
          <div>
            {
              <Badge
                color={
                  record.currentProductivity < record.expectedProductivity
                    ? 'danger'
                    : 'success'
                }
                pill
              >
                <Text
                  variant={textVariantsEnum.Text_xs}
                  fontWeight={fontWeightEnum.Medium}
                >
                  {record.currentProductivity?.toFixed(2)}%
                </Text>
              </Badge>
            }
          </div>
        );
      },
    },
    {
      title: 'Expected Productivity',
      dataIndex: 'expectedProductivity',
      key: 'id',
      render: (text, record) => {
        if (record.children) {
          return (
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
            >
              {record.expectedProductivity?.toFixed(2)}%
            </Text>
          );
        }
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {record.expectedProductivity?.toFixed(2)}%
          </Text>
        );
      },
    },
    {
      title: 'date',
      dataIndex: 'createdAt',
      key: 'id',
      render: (text, record) => {
        if (record.children) {
          return (
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
            >
              {alertsService.formatDate(text)}
            </Text>
          );
        }
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {alertsService.formatDate(text)}
          </Text>
        );
      },
    },
  ];
};
